import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Checkbox } from "@cofano/cck";
import { Grid } from "@mui/material";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<Grid xs={6} item>
			<FormGroup label={Language("LETTER_OF_PROTEST_SITUATION_HEADER")} overflow="hidden">
				<div style={{ paddingLeft: 16, paddingTop: 16 }}>
					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.situationBefore"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("BEFORE")} />} />
					</div>

					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.situationDuring"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("DURING")} />} />
					</div>

					<Controller
						name="protestVariables.situationAfter"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("AFTER")} />} />
				</div>
			</FormGroup>
		</Grid>
	);
};

